<template>
  <div class="navbar">
    <div class="container-nav">
      <nav>
        <ul>
          <li v-for="(link, idx) in navlinks" :key="idx" :class="link.dropdown ? 'claims-dropdown' : ''">
                <a class="dropdown-title" v-if="link.dropdown">{{link.text}}</a>
                <ul class="nav-dropdown" v-if="link.dropdown">
                    <li v-for="(sublink, idx) in link.dropdown" :key="idx"><router-link :to="sublink.url">{{ sublink.text }}</router-link></li>                            
                </ul>
              <router-link v-if="!link.dropdown" :to="link.url">{{ link.text }}</router-link>
          </li>

          <li v-if="!isLoggedIn" to="/login"><router-link to="/login"><i class="fas fa-user"></i>&nbsp;Login</router-link></li>
          <li v-if="isLoggedIn" class="account-dropdown">
              <a class="dropdown-account-title"><i class="fas fa-user"></i>&nbsp;{{username}}</a>
              <ul class="nav-dropdown">                        
                  <li><router-link to="/changepassword">Change password</router-link></li>
                  <li><router-link to="/logout">Logout</router-link></li>
              </ul>
          </li>                
        </ul>
      </nav>      
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { parseJwt } from '../util/parseJwt'
export default {
  name: 'topNav',
  computed: {
    navlinks() {
      var links = this.getReseller.navlinks;
      // console.log(links)
      var claimsDropdown = {};
      var standalone = process.env.VUE_APP_FORM_TYPE == 'standalone';
      var resumeLink = standalone ? { text: "Resume a claim", url: "/myclaims/inprogress" } : { text: "Resume a claim", url: "/makeaclaim/resume" };
      // console.log(resumeLink)
      if(this.getReseller.navDropdown && this.getReseller.navDropdown.dropdown.length) {
        claimsDropdown = this.getReseller.navDropdown;
        claimsDropdown.dropdown.push(resumeLink);
        
        var dropdownObj = { text: 'My Claims', dropdown: claimsDropdown.dropdown};        
        links.splice((claimsDropdown.position-1), 0, dropdownObj);
      } else {
        links.splice(2,0,resumeLink);
      }      
      // console.log(links)
      return links;
    },
    isLoggedIn () {
      if(this.$store.state.authentication.status) {
        return this.$store.state.authentication.status.loggedIn 
      } else {
        return false;
      }     
    },
    username () {
      if(this.$store.state.authentication.user.token) {
        return parseJwt(this.$store.state.authentication.user.token)['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name']
      } else {
        return '';
      }      
    },
    ...mapGetters({
      getReseller: 'reseller/getResellerInfo'
    })
  }
}
</script>